import SeoHead from '../../components/SeoHead';
import { Collection } from "@sourceflow-uk/sourceflow-sdk"
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import BlogDetail from '../../components/BlogDetail';
import AllBlogs from '../../components/AllBlogs';
import { findConsultant } from "../../hooks/useConsultants";
import Header from '../../components/MainHeader';

export default function NewsPage({
    news,
    author,
    all_consultants,
    all_blogs
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`${news.title}`}
                // description={``}
                canonical_link={`/job-seekers-news/${news.url_slug}/`}
                og_image={`${news.image}`}
            />
            <Header
                employerNav={false}
            />
            <SubBanner
                global={global}
                pathPrefix={`job_seekers_blog_page.sub_banner`}
                news={news}
                customClass={`mb-5 secondary-banner`}
                buttonTitle={`Jobseekers / News and insights`}
                buttonLink={`/job-seekers-news/`}
                post={news}
                author={author}
                all_consultants={all_consultants}

            />
            <BlogDetail
                global={global}
                news={news}
                pathPrefix={`job_seekers_blog_page.blog_detail`}
            />
            <AllBlogs
                global={global}
                pathPrefix={`job_seekers_blog_page.all_blogs`}
                all_blogs={all_blogs}
                customClass={`other-blogs mt-5 pt-5 mb-5 pb-5`}
                buttonTitle={`Read`}
                heading={`Recent articles`}
                pagePrefix={`job-seekers-news`}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const news = (await Collection('news')).getJsonItem(params.url_slug, 'url_slug');

    // Author V2 links straight to a consultant and takes precedence when filled,
    // otherwise fall back to the legacy free-text Author on older articles
    const author = news.author_v2 || news.author || "";
    const all_consultants = findConsultant(author) ?? [];

    const job_seeker_tag = "Jobseeker";
    const blogs = (await Collection("news"))
        .filter(function (post) {
            return (
                post.tag?.en.includes(job_seeker_tag)
            );
        }).filter(function (post) {
            return (
                // Checks that so no identical blog will appear on the blog page
                post.url_slug !== news.url_slug
            )
        })
    const all_blogs = blogs.orderBy('published_date').getItems().slice(0, 3);

    return {
        props: {
            news,
            author,
            all_consultants,
            all_blogs
        },
    }
}

export async function getStaticPaths() {
    const newsPaths = (await Collection('news')).getPaths('url_slug');
    return {
        paths: newsPaths,
        fallback: false
    }
}